// TODO: Update casing and make singular, i.e. TagId

enum TagIds {
  SingleOwner = 20,
  AccidentFree = 21,
  PriceDrop = 103,
  GreatDeals = 104,
  SportsVehicle = 118,
  LowMileage = 119,
  LowMilesPerYear = 120,
  RecentlyAdded = 121
}

export default TagIds;
